<template>
  <div class="box">
    <!--<div class="columns">
      <div class="column" v-for="(recent_row, index) in recent_list" :key="index" v-text="recent_row.title"></div>
    </div>-->
    <div class="field is-grouped">
      <div class="control">
        <button type="button" class="button is-danger" @click="getModalConfirmation('Back to Select Data', 'Are you sure want to clear all data and back to select your data?', 'link_back')">Back to Select Data</button>
      </div>
    </div>
    <div class="box">
      <div class="tile is-ancestor">
        <div class="tile is-parent is-12" @click="moveToGiving()">
          <article class="tile is-child notification is-link has-text-centered">
            <p class="title non-select">Giving</p>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent is-12" @click="moveToEvent()">
          <div class="tile is-child notification is-primary is-12 has-text-centered">
            <p class="title non-select">Events</p>
          </div>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent is-12" @click="moveToEventComplimentary()">
          <div class="tile is-child notification is-success is-12 has-text-centered">
            <p class="title non-select">Complimentary Tickets</p>
          </div>
        </div>
      </div>
    </div>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      recent_list: []
    }
  },
  created () {
    // this.checkServiceOpen()
    this.getDashboardData()
  },
  methods: {
    checkServiceOpen () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('frontdesk/check_service_open', {
        service: this.getSessionItem('selected_service')
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          if (response.data.data === 0) {
            self.serviceIsDone()
          }
        } else {
          self.serviceIsDone()
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getDashboardData () {
      var self = this
      self.flyPostSession('frontdesk/get_dashboard_data', {
        service_id: this.getSessionItem('selected_service'),
        counter_id: this.getSessionItem('selected_counter')
      }).then(function (response) {
        if (response.data.response_code === 1) {
          self.recent_list.push({title: 'Service : ' + response.data.data.service})
          self.recent_list.push({title: 'Counter : ' + response.data.data.counter})
          self.getEDCBankList(function (value) {
            for (var index in value) {
              if (index === '0') {
                self.recent_list.push({title: 'BCA : ' + self.getSessionItem('edc_bank_number_' + value[index].id)})
              } else {
                self.recent_list.push({title: 'Maybank : ' + self.getSessionItem('edc_bank_number_' + value[index].id)})
              }
            }
          })
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        console.log(response)
      })
    },
    serviceIsDone () {
      this.$geb.emit({id: 'alert_modal', title: 'This service is done for today.', content: 'Please select another services!', button_text: 'OK'})
      this.removeSessionItem('selected_counter')
      this.removeSessionItem('selected_service')
      this.getEDCBankList(function (value) {
        for (var index in value) {
          this.removeSessionItem('edc_bank_' + value[index].id)
          this.removeSessionItem('edc_bank_number_' + value[index].id)
        }
      })

      this.$router.push('/panel/frontdesk')
    },
    moveToGiving (type) {
      this.$router.push('/panel/frontdesk/giving/')
    },
    moveToEvent () {
      this.$router.push('/panel/frontdesk/event/')
    },
    moveToEventComplimentary () {
      this.$router.push('/panel/frontdesk/event_complimentary/')
    },
    getEDCBankList (callback) {
      var self = this
      self.flyGetSession('frontdesk/get_edc_bank')
      .then(function (response) {
        if (response.data.response_code === 1) {
          callback(response.data.data)
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    executeModalAction (confirmData) {
      var self = this
      if (confirmData.label === 'link_back') {
        if (confirmData.flag === true) {
          this.removeSessionItem('selected_counter')
          this.removeSessionItem('selected_service')
          this.getEDCBankList(function (value) {
            for (var index in value) {
              self.removeSessionItem('edc_bank_' + value[index].id)
              self.removeSessionItem('edc_bank_number_' + value[index].id)
            }
          })

          this.$router.push('/panel/frontdesk')
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .notification{
    cursor: pointer;
  }

  .non-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Dashboard.vue